import { Injectable } from '@angular/core';
import { LmsApi } from '@services/_api/lms-api';
import { ViewValues } from '../_models';

interface ReportExportType {
  actualValue: number;
  viewValue: string;
}

@Injectable({ providedIn: 'root' })
export class Constants {
  // View Values

  public reportExportType: ViewValues<LmsApi.ReportExportType>[] = [
    {
      actualValue: LmsApi.ReportExportType.Learner,
      viewValue: 'Learner',
    },
    {
      actualValue: LmsApi.ReportExportType.Attendance,
      viewValue: 'Attendance',
    },
    // {
    //   actualValue: LmsApi.ReportExportType.Learnership,
    //   viewValue: 'Learnership',
    // },
    // {
    //   actualValue: LmsApi.ReportExportType.Employer,
    //   viewValue: 'Employer',
    // },
  ];

  public activityTotalInputFormats: ViewValues<LmsApi.ActivityTotalInputFormats>[] = [
    {
      actualValue: LmsApi.ActivityTotalInputFormats.LearnerTotal,
      viewValue: 'Learner Total',
    },
    {
      actualValue: LmsApi.ActivityTotalInputFormats.FractionWithPercentageAndCompetency,
      viewValue: 'Fraction, Percentage and Competency',
    }
  ];

  public activityQuestionTypes: ViewValues<LmsApi.ActivityQuestionTypes>[] = [
    {
      actualValue: LmsApi.ActivityQuestionTypes.MultipleChoice,
      viewValue: 'Multiple Choice',
    },
    {
      actualValue: LmsApi.ActivityQuestionTypes.Paragraph,
      viewValue: 'Paragraph',
    }
  ];

  public qualificationTypes: ViewValues<LmsApi.QualificationType>[] = [
    {
      actualValue: LmsApi.QualificationType.Qcto,
      viewValue: 'QCTO',
    },
    {
      actualValue: LmsApi.QualificationType.Seta,
      viewValue: 'SETA',
    },
  ];

  public staffTypes: ViewValues<LmsApi.StaffTypes>[] = [
    {
      actualValue: LmsApi.StaffTypes.Mentor,
      viewValue: 'Mentor',
    },
    {
      actualValue: LmsApi.StaffTypes.Moderator,
      viewValue: 'Moderator',
    },
    {
      actualValue: LmsApi.StaffTypes.Assessor,
      viewValue: 'Assessor',
    },
    {
      actualValue: LmsApi.StaffTypes.Facilitator,
      viewValue: 'Facilitator',
    },
  ];

  public studentTypes: ViewValues<LmsApi.StudentTypes>[] = [
    {
      actualValue: LmsApi.StudentTypes.Learner,
      viewValue: 'Learner',
    },
    {
      actualValue: LmsApi.StudentTypes.Intern,
      viewValue: 'Intern',
    },
    {
      actualValue: LmsApi.StudentTypes.Candidate,
      viewValue: 'Candidate',
    },
  ];

  public attendanceTypes: ViewValues<LmsApi.AttendanceTypes>[] = [
    {
      actualValue: LmsApi.AttendanceTypes.Default,
      viewValue: 'Not Set',
    },
    {
      actualValue: LmsApi.AttendanceTypes.Present,
      viewValue: 'Present',
    },
    {
      actualValue: LmsApi.AttendanceTypes.Absent,
      viewValue: 'Absent',
    },
    {
      actualValue: LmsApi.AttendanceTypes.ArrivedLate,
      viewValue: 'Arrived Late',
    },
    {
      actualValue: LmsApi.AttendanceTypes.LeftEarly,
      viewValue: 'Left Early',
    },
    {
      actualValue: LmsApi.AttendanceTypes.ArrivedLateAndLeftEarly,
      viewValue: 'Arrived Late And Left Early',
    },
    {
      actualValue: LmsApi.AttendanceTypes.OnLeave,
      viewValue: 'On Leave',
    },
    {
      actualValue: LmsApi.AttendanceTypes.Sick,
      viewValue: 'Sick',
    },
    {
      actualValue: LmsApi.AttendanceTypes.PublicHoliday,
      viewValue: 'Public Holiday',
    },
    {
      actualValue: LmsApi.AttendanceTypes.NotApplicable,
      viewValue: 'N/A',
    },
    {
      actualValue: LmsApi.AttendanceTypes.Terminated,
      viewValue: 'Terminated',
    },
    {
      actualValue: LmsApi.AttendanceTypes.FamilyResponsibilitySickChild,
      viewValue: 'FR (Sick Child)',
    },
    {
      actualValue: LmsApi.AttendanceTypes.FamilyResponsibilityFuneral,
      viewValue: 'FR (Funeral)',
    },
    {
      actualValue: LmsApi.AttendanceTypes.MaternityLeave,
      viewValue: 'Maternity Leave',
    },
  ];

  public inputTypes: ViewValues<LmsApi.InputTypes>[] = [
    {
      actualValue: LmsApi.InputTypes.Text,
      viewValue: 'Text Box',
    },
    {
      actualValue: LmsApi.InputTypes.TextArea,
      viewValue: 'Text Area',
    },
    {
      actualValue: LmsApi.InputTypes.Email,
      viewValue: 'Email',
    },
    {
      actualValue: LmsApi.InputTypes.TelNumber,
      viewValue: 'Tel/cell Number',
    },
    {
      actualValue: LmsApi.InputTypes.Date,
      viewValue: 'Date',
    },
    {
      actualValue: LmsApi.InputTypes.Checkbox,
      viewValue: 'Checkbox',
    },
    {
      actualValue: LmsApi.InputTypes.Gradebox,
      viewValue: 'Gradebox',
    },
    {
      actualValue: LmsApi.InputTypes.Number,
      viewValue: 'Numeric',
    },
    {
      actualValue: LmsApi.InputTypes.ActivityTotal,
      viewValue: 'Activity Total',
    },
  ];

  public autofillInputOwners: ViewValues<LmsApi.AutoFillInputOwners>[] = [
    {
      actualValue: LmsApi.AutoFillInputOwners.Student,
      viewValue: 'Student',
    },
    {
      actualValue: LmsApi.AutoFillInputOwners.Facilitator,
      viewValue: 'Facilitator',
    },
    {
      actualValue: LmsApi.AutoFillInputOwners.Assessor,
      viewValue: 'Assessor',
    },
    {
      actualValue: LmsApi.AutoFillInputOwners.Moderator,
      viewValue: 'Moderator',
    },
    {
      actualValue: LmsApi.AutoFillInputOwners.Mentor,
      viewValue: 'Mentor',
    },
    {
      actualValue: LmsApi.AutoFillInputOwners.Manager,
      viewValue: 'Manager',
    },
  ];

  public autofillInputTypes: ViewValues<LmsApi.AutoFillInputTypes>[] = [
    {
      actualValue: LmsApi.AutoFillInputTypes.FullName,
      viewValue: 'Full Name',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.FirstName,
      viewValue: 'FirstName',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.MiddleNames,
      viewValue: 'Middle Name/s',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.LastName,
      viewValue: 'Last Name',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.IdNumber,
      viewValue: 'Id Number',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.Email,
      viewValue: 'Email',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.DateOfBirth,
      viewValue: 'Date Of Birth',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.CellNumber,
      viewValue: 'Cell Number',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.Address,
      viewValue: 'Address',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.ModeratorNumber,
      viewValue: 'Moderator Number',
    },
    {
      actualValue: LmsApi.AutoFillInputTypes.AssessorNumber,
      viewValue: 'Assessor Number',
    },
  ];

  public announcementTypes: ViewValues<LmsApi.AnnouncementMessageTypes>[] = [
    {
      actualValue: LmsApi.AnnouncementMessageTypes.General,
      viewValue: 'General Announcement',
    },
    {
      actualValue: LmsApi.AnnouncementMessageTypes.StaffAnnouncement,
      viewValue: 'Staff Announcement',
    },
    {
      actualValue: LmsApi.AnnouncementMessageTypes.StudentAnnouncement,
      viewValue: 'Student Announcement',
    },
  ];

  public announcementSeverities: ViewValues<LmsApi.AnnouncementMessageSeverities>[] =
    [
      {
        actualValue: LmsApi.AnnouncementMessageSeverities.Standard,
        viewValue: 'Standard',
      },
      {
        actualValue: LmsApi.AnnouncementMessageSeverities.Important,
        viewValue: 'Important',
      },
      {
        actualValue: LmsApi.AnnouncementMessageSeverities.Critical,
        viewValue: 'Critical',
      },
    ];

  public typesOfDocumentTypes: ViewValues<LmsApi.DocTypeCatagories>[] = [
    {
      actualValue: LmsApi.DocTypeCatagories.Staff,
      viewValue: 'Staff Document',
    },
    {
      actualValue: LmsApi.DocTypeCatagories.Student,
      viewValue: 'Student Document',
    },
    {
      actualValue: LmsApi.DocTypeCatagories.PoeGeneral,
      viewValue: 'POE General Document',
    },
    {
      actualValue: LmsApi.DocTypeCatagories.PoeAssessmentGuide,
      viewValue: 'POE Assessment Guide Document',
    },
    {
      actualValue: LmsApi.DocTypeCatagories.PoeWorkplace,
      viewValue: 'POE Workplace Document',
    },
    {
      actualValue: LmsApi.DocTypeCatagories.PoeGroupGeneral,
      viewValue: 'POE Group General Document',
    },
    {
      actualValue: LmsApi.DocTypeCatagories.PoeFormativeAssessment,
      viewValue: 'POE Formative Assessment',
    },
    {
      actualValue: LmsApi.DocTypeCatagories.PoeSummativeAssessment,
      viewValue: 'POE Summative Assessment',
    },
    {
      actualValue: LmsApi.DocTypeCatagories.Organizational,
      viewValue: 'Organizational Document',
    },
    {
      actualValue: LmsApi.DocTypeCatagories.GeneralQualAndLearnership,
      viewValue: 'Qualification/Learnership Document',
    },
  ];

  public setaTypes: ViewValues<LmsApi.SETATypes>[] = [
    {
      actualValue: LmsApi.SETATypes.AgriSETA,
      viewValue:
        'AgriSETA - Agricultural Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.BankSETA,
      viewValue: 'BANKSETA - Banking Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.Chieta,
      viewValue:
        'CHIETA - Chemical Industries Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.Ceta,
      viewValue: 'CETA - Construction Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.CathsSETA,
      viewValue:
        'CATHSSETA - Culture, Arts, Tourism, Hospitality and Sport Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.EtdpSETA,
      viewValue:
        'ETDP SETA - Education, Training and Development Practices Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.EwsSeta,
      viewValue:
        'EWSETA - Energy and Water Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.FpmSETA,
      viewValue:
        'FP&M SETA - Fibre Processing and Manufacturing Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.Fasset,
      viewValue:
        'Fasset - Finance and Accounting Services Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.FoodBevSETA,
      viewValue:
        'FoodBev SETA - Food and Beverage Manufacturing Industry Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.HwSETA,
      viewValue:
        'HWSETA - Health and Welfare Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.InSETA,
      viewValue: 'Inseta - Insurance Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.LgSETA,
      viewValue:
        'LGSETA - Local Government Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.MerSETA,
      viewValue:
        'merSETA - Manufacturing, Engineering and Related Services Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.MictSETA,
      viewValue:
        'MICT SETA - Media, Information and Communication Technologies Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.Mqa,
      viewValue: 'MQA - Mining Qualifications Authority',
    },
    {
      actualValue: LmsApi.SETATypes.PSETA,
      viewValue:
        'PSETA - Public Service Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.SasSETA,
      viewValue:
        'SASSETA - Safety and Security Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.SSeta,
      viewValue: 'SSETA - Services Sector Education and Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.Teta,
      viewValue: 'TETA - Transport Education Training Authority',
    },
    {
      actualValue: LmsApi.SETATypes.WrSeta,
      viewValue:
        'W&RSETA - Wholesale and Retail Sector Education and Training Authority',
    },
  ];

  public saqaFields: ViewValues<LmsApi.SAQAFields>[] = [
    {
      actualValue: LmsApi.SAQAFields.AgriNatureConservation,
      viewValue: 'Agriculture & Nature Conservation',
    },
    {
      actualValue: LmsApi.SAQAFields.CultureArts,
      viewValue: 'Culture & Arts',
    },
    {
      actualValue: LmsApi.SAQAFields.BusinessComsManagement,
      viewValue: 'Business, Commerce & Management',
    },
    {
      actualValue: LmsApi.SAQAFields.ComStudiesLanguage,
      viewValue: 'Communication Studies & Language',
    },
    {
      actualValue: LmsApi.SAQAFields.EducationTrainingDevelopment,
      viewValue: 'Education, Training & Development',
    },
    {
      actualValue: LmsApi.SAQAFields.ManufactureEngineerTech,
      viewValue: 'Manufacturing, Engineering & Technology',
    },
    {
      actualValue: LmsApi.SAQAFields.HumanSocialStudies,
      viewValue: 'Human & Social Studies',
    },
    {
      actualValue: LmsApi.SAQAFields.LawMilitarySecurity,
      viewValue: 'Law, Military Science & Security',
    },
    {
      actualValue: LmsApi.SAQAFields.HealthSocialServices,
      viewValue: 'Health Sciences & Social Services',
    },
    {
      actualValue: LmsApi.SAQAFields.MathPhysComputerLifeSci,
      viewValue: 'Mathematical, Physical, Computer & Life Sciences',
    },
    {
      actualValue: LmsApi.SAQAFields.Services,
      viewValue: 'Services',
    },
    {
      actualValue: LmsApi.SAQAFields.PhysicalPlanningConstrucuton,
      viewValue: 'Physical Planning & Construction',
    },
  ];

  public poeScheduleEvents: ViewValues<LmsApi.POEScheduleEvents>[] = [
    { actualValue: LmsApi.POEScheduleEvents.Custom, viewValue: 'Custom' },
    { actualValue: LmsApi.POEScheduleEvents.Induction, viewValue: 'Induction' },
    { actualValue: LmsApi.POEScheduleEvents.Workplace, viewValue: 'Workplace' },
    {
      actualValue: LmsApi.POEScheduleEvents.ReAssessment,
      viewValue: 'Re-Assessment',
    },
    {
      actualValue: LmsApi.POEScheduleEvents.SkillsProgrammeFormative,
      viewValue: 'Formative',
    },
    {
      actualValue: LmsApi.POEScheduleEvents.SkillsProgrammeSummativeSubmission,
      viewValue: 'Summative Submission',
    },
    {
      actualValue: LmsApi.POEScheduleEvents.SkillsProgrammeSummativeFeedback,
      viewValue: 'Summative Feedback',
    },
    {
      actualValue: LmsApi.POEScheduleEvents.SkillsProgrammeAssessmentPlan,
      viewValue: 'Assessment Plan',
    },
    {
      actualValue: LmsApi.POEScheduleEvents.SkillsProgrammeModerationPlan,
      viewValue: 'Moderation Plan',
    },
  ];

  public titles: ViewValues<LmsApi.Titles>[] = [
    { actualValue: LmsApi.Titles.Mr, viewValue: 'Mr' },
    { actualValue: LmsApi.Titles.Mrs, viewValue: 'Mrs' },
    { actualValue: LmsApi.Titles.Miss, viewValue: 'Miss' },
    { actualValue: LmsApi.Titles.DrMd, viewValue: 'Dr (MD)' },
    { actualValue: LmsApi.Titles.DrPhD, viewValue: 'Dr (PhD)' },
  ];

  public genders: ViewValues<LmsApi.Genders>[] = [
    { actualValue: LmsApi.Genders.Male, viewValue: 'Male' },
    { actualValue: LmsApi.Genders.Female, viewValue: 'Female' },
    { actualValue: LmsApi.Genders.Other, viewValue: 'Other' },
  ];

  public idTypes: ViewValues<LmsApi.IdTypes>[] = [
    { actualValue: LmsApi.IdTypes.SouthAfrican, viewValue: 'SA ID' },
    { actualValue: LmsApi.IdTypes.Passport, viewValue: 'Passport' },
  ];

  public nationalities: ViewValues<LmsApi.Nationalities>[] = [
    {
      actualValue: LmsApi.Nationalities.SouthAfrican,
      viewValue: 'South African',
    },
    { actualValue: LmsApi.Nationalities.Angolan, viewValue: 'Angolan' },
    { actualValue: LmsApi.Nationalities.Botswanan, viewValue: 'Botswanan' },
    { actualValue: LmsApi.Nationalities.Mozambican, viewValue: 'Mozambican' },
    { actualValue: LmsApi.Nationalities.Namibian, viewValue: 'Namibian' },
    { actualValue: LmsApi.Nationalities.Nigerian, viewValue: 'Nigerian' },
    { actualValue: LmsApi.Nationalities.Ugandan, viewValue: 'Ugandan' },
    { actualValue: LmsApi.Nationalities.Zimbabwean, viewValue: 'Zimbabwean' },
    { actualValue: LmsApi.Nationalities.Zambian, viewValue: 'Zambian' },
    { actualValue: LmsApi.Nationalities.Other, viewValue: 'Other' },
  ];

  public races: ViewValues<LmsApi.Races>[] = [
    { actualValue: LmsApi.Races.African, viewValue: 'African' },
    { actualValue: LmsApi.Races.White, viewValue: 'White' },
    { actualValue: LmsApi.Races.Colored, viewValue: 'Colored' },
    { actualValue: LmsApi.Races.Indian, viewValue: 'Indian' },
    { actualValue: LmsApi.Races.Other, viewValue: 'Other' },
  ];

  public languages: ViewValues<LmsApi.Languages>[] = [
    { actualValue: LmsApi.Languages.English, viewValue: 'English' },
    { actualValue: LmsApi.Languages.Afrikaans, viewValue: 'Afrikaans' },
    { actualValue: LmsApi.Languages.Ndebele, viewValue: 'Ndebele' },
    {
      actualValue: LmsApi.Languages.NorthernSotho,
      viewValue: 'Northern Sotho',
    },
    { actualValue: LmsApi.Languages.Sesotho, viewValue: 'Sesotho' },
    { actualValue: LmsApi.Languages.Swati, viewValue: 'Swati' },
    { actualValue: LmsApi.Languages.Tsonga, viewValue: 'Tsonga' },
    { actualValue: LmsApi.Languages.Tswana, viewValue: 'Tswana' },
    { actualValue: LmsApi.Languages.Venda, viewValue: 'Venda' },
    { actualValue: LmsApi.Languages.Xhosa, viewValue: 'Xhosa' },
    { actualValue: LmsApi.Languages.Zulu, viewValue: 'Zulu' },
    { actualValue: LmsApi.Languages.Pedi, viewValue: 'Pedi' },
    { actualValue: LmsApi.Languages.SouthAfricanSignLanguage, viewValue: 'South African Sign Language' },
    { actualValue: LmsApi.Languages.Other, viewValue: 'Other' },
  ];

  public poeFolders: ViewValues<LmsApi.POEFolders>[] = [
    { actualValue: LmsApi.POEFolders.General, viewValue: 'General' },
    {
      actualValue: LmsApi.POEFolders.AssessmentGuide,
      viewValue: 'Assessment Guide',
    },
    { actualValue: LmsApi.POEFolders.Feedback, viewValue: 'Feedback' },
    { actualValue: LmsApi.POEFolders.Workplace, viewValue: 'Workplace' },
    {
      actualValue: LmsApi.POEFolders.GroupFormativeAssessments,
      viewValue: 'Formative Assessment',
    },
    {
      actualValue: LmsApi.POEFolders.GroupSummativeAssessments,
      viewValue: 'Summative Assessment',
    },
    { actualValue: LmsApi.POEFolders.GroupSaqaDocs, viewValue: 'SAQA' },
    { actualValue: LmsApi.POEFolders.GroupGeneral, viewValue: 'Group General' },
  ];

  public countries: ViewValues<LmsApi.Countries>[] = [
    { actualValue: LmsApi.Countries.SouthAfrica, viewValue: 'South Africa' },
    { actualValue: LmsApi.Countries.Angola, viewValue: 'Angola' },
    { actualValue: LmsApi.Countries.Botswana, viewValue: 'Botswana' },
    { actualValue: LmsApi.Countries.Mozambique, viewValue: 'Mozambique' },
    { actualValue: LmsApi.Countries.Namibia, viewValue: 'Namibia' },
    { actualValue: LmsApi.Countries.Nigeria, viewValue: 'Nigeria' },
    { actualValue: LmsApi.Countries.Uganda, viewValue: 'Uganda' },
    { actualValue: LmsApi.Countries.Zimbabwe, viewValue: 'Zimbabwe' },
    { actualValue: LmsApi.Countries.Zambia, viewValue: 'Zambia' },
    { actualValue: LmsApi.Countries.Other, viewValue: 'Other' },
  ];

  //String arrays

  public provinces: string[] = [
    'Gauteng',
    'Free State',
    'Eastern Cape',
    'KwaZulu-Natal',
    'Limpopo',
    'Mpumalanga',
    'North West',
    'Northern Cape',
    'Western Cape',
  ];

  public cities: string[] = [
    'Johannesburg',
    'Germiston',
    'Benoni',
    'Alberton',
    'Pretoria',
    'Randburg',
    'Heidelberg',
    'Krugersdorp',
    'Magaliesburg',
    'Midrand',
    'Sandton',
    'Soweto',
    'Vanderbijlpark',
    'Vereeniging',
  ];

  public suburbs: string[] = [
    'Abbotsford',
    'Activia Park',
    'Actonville',
    'Airfield',
    'Akasia',
    'Alan Manor',
    'Alberante',
    'Albermarle',
    'Alberton',
    'Albertsdal',
    'Albertskroon',
    'Albertville',
    'Aldara Park',
    'Alexandra',
    'Allen Grove',
    'Alphen Park',
    'Alphenpark',
    'Alrapark',
    'Alrode',
    'Amandasig',
    'Amberfield',
    'Annlin',
    'Annlin-Wes',
    'Antwerp',
    'Anzac',
    'Apple Park',
    'Arcadia',
    'Arconpark',
    'Armadale',
    'Ashlea Gardens',
    'Aspen Lakes',
    'Aston Manor',
    'Atholl Gardens',
    'Atlasville',
    'Atteridgeville',
    'Auckland Park',
    'AureusAustin View',
    'Azaadville',
    'Baileys Muckleneuk',
    'Bakenkop',
    'Bapsfontein',
    'Barbeque Downs',
    'Bardene Ext 2',
    'Bartlett Ext 20',
    'Bassonia',
    'Baviaanspoort',
    'Beaulieu',
    'Bedfordview',
    'Bedworth Park',
    'Bekkersdal',
    'BellevueBenmore Gardens',
    'Benoni',
    'Berario',
    'Berea',
    'Bergbron',
    'Bergsig',
    'Berton Park',
    'Bertrams',
    'Beverley Gardens',
    'Beverley Hills',
    'Beyerspark',
    'Bezuidenhoutsvallei',
    'Birch Acres',
    'Birchleigh',
    'Birchleigh North',
    'Birdhaven',
    'Birnam Park',
    'Blackheath',
    'Blairgowrie',
    'Bloubosrand',
    'Blue Hills',
    'Boipatong',
    'Boksburg',
    'Boksburg Noord',
    'Boksburg Wes',
    'Boksburg-Noord',
    'Boksburg-Suid',
    'Bolton Wold AH',
    'Boltonia',
    'Bonaero Park',
    'Bonanne',
    'Booysens',
    'Booysens Reserve',
    'Bophelong',
    'Bordeaux',
    'Boskruin',
    'Bosmont',
    'Braamfontein',
    'Bracken Downs',
    'Brackenhurst',
    'Brakpan',
    'Bramley',
    'Bramley Gardens',
    'Breaunanda',
    'Brenthurst',
    'Brentwood',
    'Brixton',
    'Broadacres AH',
    'Bromhof',
    'Bronberrik',
    'Bronkhorstspruit',
    'Brooklyn',
    'Bruma',
    'Brummeria',
    'Bryanston',
    'Bryanston West Ext 1',
    'Bryntirion',
    'Buccleuch',
    'Burgershoop',
    'Buyscelia AH',
    'Caleni',
    'Capital Park',
    'Carenvale',
    'Carlswald',
    'Cason',
    'Casseldale',
    'Castleview',
    'Celtisdal',
    'Centurion',
    'Centurion Golf Estate',
    'Cerutiville',
    'Chantelle',
    'Chloorkop',
    'Christoburg',
    'Chrisville',
    'Cinderella',
    'Claremont',
    'Clarina',
    'Claudius',
    'Clayville',
    'Clubview',
    'Clubview East',
    'Colbyn',
    'Comet',
    'Constantia Kloof',
    'Constantiapark',
    'Coronationville',
    'Cosmo City',
    'Cottesloe',
    'Craigavon',
    'Craighall Park',
    'Cress Lawn',
    'Cresta',
    'Creswell Park',
    'Crosby',
    'Crown Gardens',
    'Crowthorne',
    'Croydon',
    'Crystal Park',
    'Culemborgpark',
    'Cullinan',
    'Cultura Park',
    'Cyrildene',
    'Daleside',
    'Dalpark',
    'Dalview',
    'Dan Pienaarville',
    'Danville',
    'Darrenwood',
    'Daspoort',
    'Daspoort Estate',
    'Daveyton',
    'Davidsonville',
    'Dawnview',
    'Dayan Glen',
    'De Beers',
    'De Fontein',
    'De Klerkshof',
    'De Wetshof',
    'Delarey',
    'Delmore',
    'Delporton',
    'Delville',
    'Denneoord',
    'Denver',
    'Derdepoort Tuindorp',
    'Dersley',
    'Dewald Hattinghpark',
    'Dibutsu',
    'Dicksonville',
    'Die Wilgers',
    'Diepkloof',
    'Dinwiddie',
    'Discovery',
    'Dlamini',
    'Dobsonville',
    'Dobsonville Gardens',
    'Doornkloof East',
    'Doornpoort',
    'Doornrandje',
    'Dorandia',
    'Doringkloof',
    'Douglasdale',
    'Douglasdale Ext 99',
    'Dowerglen',
    'Dube',
    'Duncanville',
    'Dunkeld',
    'Dunvegan',
    'Duxberry',
    'Eagle Canyon',
    'East Lynne',
    'East Town',
    'Eastgate',
    'Eastvale',
    'Edelweiss',
    'Eden Glen',
    'Edenvale',
    'Edleen',
    'Eersterus',
    'Eikepark',
    'Elandsfontein Rail',
    'Elandshaven',
    'Elandspark',
    'Elandspoort',
    'Elarduspark',
    'Eldoraigne',
    'Electron',
    'Elmapark',
    'Eloffsdal',
    'Elsburg',
    'Elspark',
    'Emdeni',
    'Emmarentia',
    'Endulweni',
    'Erasmia',
    'Erasmus',
    'Erasmuskloof',
    'Erasmusrand',
    'Esprit Estate',
    'Esselenpark',
    'Essexwold',
    'Estera',
    'Estherpark',
    'Ethafeni',
    'Evaton',
    'Evaton North',
    'Evaton Small Farms',
    'Everleigh',
    'Faerie Glen',
    'Fairland',
    'Fairmount',
    'Falcon Ridge',
    'Farrar Park',
    'Farrarmere',
    'Farrarmere Gardens',
    'Ferndale',
    'Ferryvale',
    'Finetown',
    'Finsbury',
    'Fir Grove',
    'Fleurhof',
    'Flora Gardens',
    'Floracliffe',
    'Florauna',
    'Florida',
    'Florida Glen',
    'Florida Hills',
    'Florida Lake',
    'Florida North',
    'Florida Park',
    'Fontainebleau',
    'Fordsburg',
    'Forest Town',
    'Fourways',
    'Freeway Park',
    'Ga-Rankuwa',
    'Gallo Manor',
    'Garden Ross',
    'Garsfontein',
    'Geduld',
    'Geestveld AH',
    'Generaal Albertspark',
    'Georgetown',
    'Georginia',
    'Gerdview',
    'Gerhardsville',
    'Germiston',
    'Germiston South',
    'Gezina',
    'Gillview',
    'Glen Lauriston',
    'Glenanda',
    'Gleneagles',
    'Glenharvie',
    'Glenhazel',
    'Glenmarais',
    'Glenvarloch',
    'Glenvista',
    'Goedeburg',
    'Golf Park',
    'Government Village',
    'Gqagqeni',
    'Green Hills',
    'Greenside',
    'Greymont',
    'Groblerpark',
    'Groeneweide',
    'Groenkloof',
    'Grootvaly SH',
    'Haddon',
    'Halfway House',
    'Hamberg',
    'Harmelia',
    'Hatfield',
    'Hazeldene',
    'Hazelwood',
    'Heatherdale',
    'Hectorton',
    'Helderkruin',
    'Helikonpark',
    'Henley on Klip',
    'Hennopspark',
    'Heritage Hill',
    'Hermanstad',
    'Hesteapark',
    'Heuweloord',
    'Heuwelsig',
    'Highbury',
    'Highlands North',
    'Highway Gardens',
    'Hillbrow',
    'Hillcrest',
    'Hillshaven',
    'Hillside AH',
    'Home Lake',
    'Homelands AH',
    'Homer',
    'Homestead',
    'Homestead Park',
    'Honeydew',
    'Honeyhill',
    'Horison',
    'Horisonpark',
    'Horizon View',
    'Hospital View',
    'Houghton Estate',
    'Houtkapper Park',
    'Hurlingham',
    'Hurlingham Gardens',
    'Hurlyvale',
    'Hursthill',
    'Huttingdon',
    'Illiondale',
    'Illovo',
    'Impala Park',
    'Inanda',
    'Industrial',
    'Isandovale',
    'Isekelo',
    'Ivory Park',
    'Jabavu',
    'Jacanlee',
    'Jan Niemandpark',
    'Jan Smutsville',
    'Jansenpark',
    'Jeppestown',
    'Jiyana',
    'Johandeo AH',
    'Johannesburg North',
    'Jordaanpark',
    'Jukskeipark',
    'Kagiso',
    'Kameeldrift',
    'Karenpark',
    'Kelland',
    'Kelvin',
    'Kempton Park',
    'Kempton Park West',
    'Kengies Ext 21',
    'Kenleaf',
    'Kenmare',
    'Kensington B',
    'Kew',
    'Khumalo Valley',
    'Kilfenora',
    'Killarney',
    'Kilner Park',
    'Kirkney',
    'Kleinfontein Lake',
    'Kleve Hill Park',
    'Klippan',
    'Klippoortjie',
    'Kliprivier',
    'Klipriviersoog',
    'Klipspruit',
    'Kloof',
    'Kloofendal',
    'Kloofsig',
    'Klopperpark',
    'Knights',
    'Kocksoord',
    'Kookrus',
    'Kopanong',
    'Krugersdorp West',
    'Krugersdorp-Noord',
    'Krugersrus',
    'Kruinhof',
    'Kwaggasrand',
    'La Concorde',
    'La Montagne',
    'La Rochelle',
    'Lady Selborne',
    'Lakefield',
    'Lambton',
    'Lammermoor',
    'Langlaagte North',
    'Largo',
    'Larrendale',
    'Laudium',
    'Laversburg',
    'Leeuhof',
    'Lekaneng',
    'Lenasia',
    'Lenasia South',
    'Leondale',
    'Leratong Village',
    'Les Marais',
    'Lewisham',
    'Libradene',
    'Lifateng',
    'Lilianton',
    'Lindbergh Park',
    'Linden',
    'Lindhaven',
    'Linksfield',
    'Linksfield North',
    'Linksfield Ridge',
    'Linksview',
    'Linmeyer',
    'Little Falls',
    'Lodeyko',
    'Lombardy East',
    'Lona',
    'Lonehill',
    'Lotus Gardens',
    'Lukasrand',
    'Lydiana',
    'Lyme Park',
    'Lyndhurst',
    'Lynnwood',
    'Lynnwood Glen',
    'Lynnwood Manor',
    'Lynnwood Park',
    'Lynnwood Ridge',
    'Lyttelton',
    'Lyttelton Manor',
    'Lyttleton A.H.',
    'Lyttleton L.H.',
    'Mabopane',
    'Mackenzie Park',
    'Mackenzieville',
    'Magalieskruin',
    'Magaliesmoot',
    'Magaliessig',
    'Makhulong',
    'Malanshof',
    'Malvern',
    'Malvern East',
    'Mamelodi',
    'Mandela Village',
    'Manufacta',
    'Maokeng',
    'Maphanga',
    'Marais Steyn Park',
    'Maraisburg',
    'Marlands',
    'Marlboro',
    'Maroeladal',
    'Maroelana',
    'Martindale',
    'Matika',
    'Mayfair',
    'Mayfair West',
    'Mayfield',
    'Mayville',
    'Meadowbrook',
    'Meadowhurst',
    'Meadowlands East',
    'Meadowlands West',
    'Megawatt Park',
    'Melrose',
    'Melrose North',
    'Menlo Park',
    'Menlyn',
    'Meyersdal',
    'Meyerspark',
    'Meyerton',
    'Meyerton Park',
    'Mfuyaneni',
    'Middelvlei AH',
    'Midfield Estate',
    'Midlands Estate',
    'Midstream Estate',
    'Mindalore',
    'Mindalore North',
    'Mmangweni',
    'Mnonjaneni',
    'Modderbee',
    'Moedi',
    'Moffat View',
    'Mofolo',
    'Mofolo North',
    'Mofolo South',
    'Moleleki',
    'Moletsane',
    'Mondeor',
    'Mont Lorraine',
    'Montana',
    'Montanapark',
    'Montclare',
    'Montgomery Park',
    'Montroux',
    'Monument',
    'Monumentpark',
    'Mooikloof',
    'Mooikloof Estate',
    'Mooikloof Hillls',
    'Morehill',
    'Moreleta Kloof',
    'Moreletapark',
    'Moret',
    'Morgan Ridge',
    'Morninghill',
    'Morningside',
    'Morningside Manor',
    'Moroka',
    'Motsu',
    'Mountain View',
    'Mqansa',
    'Mthambeka',
    'Mthembu Village',
    'Muckleneuk',
    'Mulbarton',
    'Munsieville',
    'Murrayfield',
    'N12 Highway Park',
    'Naledi',
    'Naturena',
    'Navors',
    'Ncala',
    'Nespark',
    'Nestadt',
    'New Modder',
    'New Muckleneuk',
    'New State Areas',
    'Newclare',
    'Nigel',
    'Nimrodpark',
    'Ninapark',
    'Noldick',
    'Noordgesig',
    'Noordhang',
    'Noordheuwel',
    'Noordwyk',
    'Norkem Park',
    'North Riding',
    'North Villa',
    'Northcliff',
    'Northgate',
    'Northmead',
    'Northwold',
    'Norwood',
    'Noycedale',
    'Ntshonalanga',
    'Nxiweni',
    'Oakdene',
    'Oaklands',
    'Ohinimuri',
    'Olivanna',
    'Olivedale',
    'Ontdekkerspark',
    'Ophirton',
    'Oranjehof',
    'Orchards',
    'Oriel',
    'Orlando',
    'Orlando East',
    'Orlando Ekhaya',
    'Orlando West',
    'Ormonde',
    'Ormonde View',
    'Paarlshoop',
    'Parkdene',
    'Parkhill Gardens',
    'Parkhurst',
    'Parkmore',
    'Parktown',
    'Parktown North',
    'Parkview',
    'Parkwood',
    'Paul Krugersoord',
    'Paulshof',
    'Peacehaven',
    'Persequor',
    'Petersfield',
    'Petervale',
    'Petit',
    'Philip Nel Park',
    'Pierre van Ryneveld',
    'Plantation',
    'Pollak Park',
    'President Park',
    'President Ridge',
    'Presidentsdam',
    'Pretoria Central',
    'Pretoria Gardens',
    'Pretoria North',
    'Pretoria Tuine',
    'Pretoria-Wes',
    'Pretoriuspark',
    'Pretoriusstad',
    'Primrose',
    'Primrose Hill',
    'Princess',
    'Proclamation Hill',
    'Protea Glen',
    'Protea North',
    'Protea South',
    'Pumulani',
    'Putfontein',
    'Queenswood',
    'Quellerina',
    'Quellieriepark',
    'Rabie Ridge',
    'Raceview',
    'Radiokop',
    'Randburg',
    'Randfontein',
    'Randgate',
    'Randhart',
    'Randjespark',
    'Randpark',
    'Randpark Ridge',
    'Randpoort',
    'Rangeview',
    'Rant-en-Dal',
    'Raslouw',
    'Ratanda',
    'Ravenswood',
    'Rayton',
    'Redan',
    'Reefhaven',
    'Reigerpark',
    'Rembrandtpark',
    'Rensburgdorp',
    'Rethabiseng',
    'Rhodesfield',
    'Ridgeway',
    'Rietfontein',
    'Rietondale',
    'Rietvallei 241-IQ',
    'Rietvalleipark',
    'Risana',
    'Risi Sh',
    'Risidale',
    'Risiville',
    'River Club',
    'Riverlea',
    'Riversdale',
    'Riviera',
    'Rivonia',
    'Rivonia Gardens',
    'Robertsham',
    'Robertville',
    'Robin Acres',
    'Robin Hills',
    'Robin Park',
    'Robindale',
    'Roodebult',
    'Roodekrans',
    'Roodepoort',
    'Roodepoort-Noord',
    'Roodepoort-Wes',
    'Rooihuiskraal',
    'Rooihuiskraal-Noord',
    'Rooiwal',
    'Roseacre',
    'Rosemary Park',
    'Rosettenville',
    'Roseville',
    'Rosherville',
    'Rosslyn',
    'Rossmore',
    'Rothdene',
    'Rowhill',
    'Ruiterhof',
    'Rus ter Vaal',
    'Rynfield',
    'Rynsoord',
    'Salieshoek',
    'Sallies Village',
    'Salvokop',
    'Sandhurst',
    'Sandown',
    'Sandringham',
    'Sangweni',
    'Savoy Estate',
    'Saxonwold',
    'Scientia',
    'Sebokeng',
    'Selcourt',
    'Selection Park',
    'Selwyn',
    'Senderwood',
    'Shalimar Ridge',
    'Sharon Park',
    'Sharonlea',
    'Sharpeville',
    'Shere',
    'Silverfields',
    'Silverfields Park',
    'Silverton',
    'Silvertondale',
    'Simarlo AH',
    'Simunye',
    'Sinoville',
    'Sithame',
    'Sivana',
    'Sizanani Village',
    'Sizibeni',
    'Slovoville',
    'Solheim',
    'Sonlandpark',
    'Sonneglans',
    'Soteba',
    'South Hills',
    'South View',
    'Southcrest',
    'Springcol',
    'Springs',
    'Springs Country Club',
    'Spruitview',
    'Steel Park',
    'Sterrewag',
    'Strathavon',
    'Stretford',
    'Strubensvallei',
    'Strubenvale',
    'Struisbult',
    'Strydom Park',
    'Sub-Nigel',
    'Suiderberg',
    'Suideroord',
    'Summerfields',
    'Sunderland Ridge A.H.',
    'Sundowner',
    'Sunningdale Ridge',
    'Sunninghill',
    'Sunnyridge',
    'Sunnyrock',
    'Sunnyside',
    'Sunward Park',
    'Swaeltjie A.H.',
    'Symhurst',
    'Technikon',
    'Tedstoneville',
    'Tembisa',
    'Temong',
    'Tenacres AH',
    'Terenure',
    'Thatchfield',
    'The Gardens',
    'The Hills',
    'The Orchards',
    'The Reeds',
    'The Stewards',
    'The Wilds',
    'The Woodlands',
    'Thembilisha',
    'Theresapark',
    'Theta',
    'Thiteng',
    'Thornbrook Golf Estate',
    'Three Rivers',
    'Three Rivers East',
    'Tileba',
    'Toekomsrus',
    'Tornado',
    'Towerby',
    'Townsview',
    'Trevenna',
    'Triomf',
    'Troyeville',
    'Tshepiso',
    'Tshepisong',
    'Tsongweni',
    'Tugela Park',
    'Tulisa',
    'Tulisa Park',
    'Turf Club',
    'Turffontein',
    'Twala',
    'Unitas Park',
    'Val De Grace',
    'Valeriedene',
    'Valhalla',
    'Valtaki',
    'Van Dykpark',
    'Van Riebeeck Park',
    'Vandia Grove',
    'Ventershof AH',
    'Venterspos',
    'Versterpark',
    'Verwoerdpark',
    'Victory Park',
    'Villa Liza',
    'Villieria',
    'Visagiepark',
    'Vlakfontein 238-Iq',
    'Vleikop AH',
    'Voortrekkerhoogte',
    'Vorna Valley',
    'Vorsterpark AH',
    'Vosloorus',
    'Vrededorp',
    'Vusimuzi',
    'Wagterskop',
    'Waldrif',
    'Wapadrand',
    'Waterkloof',
    'Waterkloof Glen',
    'Waterkloof Heights',
    'Waterkloof Ridge',
    'Waterkloofpark',
    'Waterpan',
    'Waterval',
    'Waterval Estate',
    'Waverley',
    'Weavind Park',
    'Welgedacht',
    'Weltevredenpark',
    'Welumlambo',
    'Wendywood',
    'Wentworth Park',
    'Wes-Turffontein',
    'Wespark',
    'West Porges',
    'Westbury Ext 2',
    'Westbury Ext 3',
    'Westcliff',
    'Westdene',
    'Western Extension',
    'Westonaria',
    'Westside Park',
    'White City',
    'Whiteridge',
    'Wierdapark',
    'Wilfordon',
    'Wilgeheuwel',
    'Willow Wild',
    'Willowway x9',
    'Wilropark',
    'Windmill Park',
    'Windsor East',
    'Windsor Glen',
    'Windsor West',
    'Wingate Park',
    'Witfield',
    'Witkoppen',
    'Witkoppie Ridge',
    'Witpoortjie',
    'Wolmer',
    'Wonderboom',
    'Wonderboom South',
    'Woodmead',
    'Woodmead East',
    'Wright Park',
    'Wychwood',
    'Yeoville',
    'Zakariyya Park',
    'Zeekoegat',
    'Zola',
    'Zonkizizwe',
    'Zwartkop',
  ];

  public monthNames: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  public connectedUserTypes: string[] = ['Staff', 'Student'];

  //Helper methods

  public setaTypeViewValue(seta: LmsApi.SETATypes) {
    switch (seta) {
      case LmsApi.SETATypes.AgriSETA:
        return 'AgriSETA';
      case LmsApi.SETATypes.BankSETA:
        return 'BANKSETA';
      case LmsApi.SETATypes.Chieta:
        return 'CHIETA';
      case LmsApi.SETATypes.Ceta:
        return 'CETA';
      case LmsApi.SETATypes.CathsSETA:
        return 'CATHSSETA';
      case LmsApi.SETATypes.EtdpSETA:
        return 'ETDP SETA';
      case LmsApi.SETATypes.EwsSeta:
        return 'EWSETA';
      case LmsApi.SETATypes.FpmSETA:
        return 'FP&M SETA';
      case LmsApi.SETATypes.Fasset:
        return 'Fasset';
      case LmsApi.SETATypes.FoodBevSETA:
        return 'FoodBev SETA';
      case LmsApi.SETATypes.HwSETA:
        return 'HWSETA';
      case LmsApi.SETATypes.InSETA:
        return 'Inseta';
      case LmsApi.SETATypes.LgSETA:
        return 'LGSETA';
      case LmsApi.SETATypes.MerSETA:
        return 'merSETA';
      case LmsApi.SETATypes.MictSETA:
        return 'MICT SETA';
      case LmsApi.SETATypes.Mqa:
        return 'MQA';
      case LmsApi.SETATypes.PSETA:
        return 'PSETA';
      case LmsApi.SETATypes.SasSETA:
        return 'SASSETA';
      case LmsApi.SETATypes.SSeta:
        return 'SSETA';
      case LmsApi.SETATypes.Teta:
        return 'TETA';
      case LmsApi.SETATypes.WrSeta:
        return 'W&RSETA';
      default:
        return '';
    }
  }

  public getMonthName(date: Date | string) {
    if (typeof date === 'string') {
      date = new Date(date);
    }

    return this.monthNames[date.getMonth()];
  }

  public getViewValue<TActual>(
    arr: ViewValues<TActual>[],
    val: TActual
  ): string {
    return arr.find((x) => x.actualValue === val)?.viewValue ?? '';
  }
}
